<script lang="ts">
    import cx from 'classnames';
    import type { TNavItem } from './types';

    export let items: TNavItem[];
</script>

<nav class="flex items-center justify-center gap-md desktop-l:px-sm">
    {#each items as { href, text, selected, enabled, testid }}
        {#if enabled}
            <a
                class={cx('text my-auto text-sm tablet:text-base', {
                    'text-white underline decoration-yellow-30 decoration-2 underline-offset-4':
                        selected,
                    'text-purple-0': !selected
                })}
                {href}
                data-testid={testid}
            >
                {text}
            </a>
        {/if}
    {/each}
</nav>
